import { useSnackbar } from 'notistack';

const useCustomSnackbar = () => {

  const { enqueueSnackbar } = useSnackbar();

  const showSnackbar = (variant, message, position = { vertical: 'top', horizontal: 'right' }, duration = 1500) => {
    console.log("Snackbar Triggered:", { variant, message });
    enqueueSnackbar(message, {
      variant,
      anchorOrigin: position,
      autoHideDuration: duration,
    });
  };

  return showSnackbar;
};

export default useCustomSnackbar;
